<script>
import {list} from '@/domain/negocio/services/negocio'
import {UTable, UTh, UTr, UTd, UCheckbox, date, LocalStorage, UTooltip, UProgress} from 'uloc-vue'
import MenuOptions from '@/components/layout/context-menu/context-window-options'
import {ErpInput, /*ErpSelect,*/ ErpSField} from 'uloc-vue-plugin-erp'
import {datePtToEn} from '@/utils/date'
import ECol from "components/layout/components/Col.vue"
import EBtn from "@/plugins/uloc-erp/components/button/EBtn"
import ERow from "components/layout/components/Row.vue"
import FiltrosAdicionais from "components/console/components/suporte/tarefas/include/ListFilters.vue"
import listOptions from "components/usuario/v2/window/listOptions"
import filters from "@/domain/negocio/helpers/filters"
import {addDays, differenceInHours, endOfWeek, format, parseISO, startOfWeek, subDays} from "date-fns";
import {listName, listStorage} from "./config/list"
import CheckSvg from "@/assets/images/CheckSvg.vue"
import AlertSvg from "@/assets/images/AlertSvg.vue"
import StatusNegocioSelect from "components/negocio/components/inputs/StatusNegocioSelect.vue";

export default {
  name: 'CrmLista',
  provide: function () {
    return {
      container: this
    }
  },
  props: {
    processo: {required: false}
  },
  mixins: [
    //DefaultMixin
  ],
  components: {
    StatusNegocioSelect,
    AlertSvg,
    CheckSvg,
    ERow,
    ECol,
    // DateInput,
    // SearchFilter,
    UTable,
    UTh,
    UTr,
    UTd,
    //UCheckbox,
    ErpInput,
    EBtn,
    // ErpSelect,
    ErpSField,
    FiltrosAdicionais,
    // UTooltip,
  },
  beforeCreate() {
    this.listStorage = listStorage
  },
  data () {
    const f = JSON.parse(JSON.stringify(filters))
    f.status = {label: 'Somente Ativos', value: 'ativos'}
    return {
      listName: listName,
      listStorage: this.listStorage,
      filtersData: {
        uf: {
          loading: true,
          serverData: []
        }
      },
      showFilters: false,
      table: {
        busca: '',
        serverData: [],
        serverPagination: {
          page: 1,
          rowsNumber: 10, // specifying this determines pagination is server-side
          rowsPerPage: 20
        },
        columns: listStorage.map(o => {
          return {
            ...o,
            field: o.name,
            align: 'left'
          }
        }).concat([
          {
            name: 'options',
            required: true,
            label: '',
            field: 'options',
            sortable: false
          }
        ]),
        filter: '',
        filters: f,
        selected: [],
        loading: false
      },
      stats: {
        cadastradosHoje: 0,
        cadastradosSemana: 0,
        paraAnalisar: 0
      },
      statsFilterActive: null
    }
  },
  computed: {
    visibledColumns() {
      return this.listStorage.filter(item => item.active).map(item => item.name)
    },
    menuDashOptions () {
      return MenuOptions
    }
  },
  mounted () {
    this.load()
  },
  destroyed () {
  },
  methods: {
    listOptions: listOptions,
    updateListDefinition(newConfig) {
      LocalStorage.set(this.listName, newConfig)
      this.listStorage = newConfig
    },
    isOpen (task) {
      return task.status.type === 'opened'
    },
    atraso (d) {
      return Math.ceil(differenceInHours(parseISO(d.date || d), new Date()) / 24) * -1
    },
    abrir(t) {
      this.$router.push({
        name: 'console.tarefa',
        params: {
          id: t.id
        }
      })
    },
    trClass (task) {
      const css = []
      if (this.colorize) {
        if (task.deadline && this.atraso(task.deadline) > 0) {
          css.push('sla-out')
        }
      }
      return css
    },
    request({pagination, filter}) {

      // this.table.serverPagination.rowsNumber = 0

      let data1, data2
      let extraFilters = []

      if (this.table.filters.data1) {
        if (this.table.filters.data1.length < 10 || (!this.table.filters.data2 || this.table.filters.data2.length < 10)) {
          alert('Digite a data inicial e data final corretamente para o filtro de entrada.')
          return
        }

        data1 = datePtToEn(this.table.filters.data1)
        data2 = datePtToEn(this.table.filters.data2)
        if (!date.isValid(data1) || !date.isValid(data2)) {
          alert('Digite a data inicial e data final corretamente. Formato: dd/mm/yyyy')
          return
        }
        extraFilters.push(`&data1=${data1}&data2=${data2}`)
      }

      this.table.filters.tipoData && extraFilters.push(`&typeDate=${this.table.filters.tipoData}`)

      this.table.filters.search && extraFilters.push(`&search=${String(this.table.filters.search).replace('#', '_hash-')}`)

      this.table.filters.id && extraFilters.push(`&id=${this.table.filters.id}`)
      this.table.filters.tipo && extraFilters.push(`&type=${this.table.filters.tipo}`)
      this.table.filters.active && extraFilters.push(`&active=${this.table.filters.active}`)
      this.processo && this.processo.id && extraFilters.push(`&processo=${this.processo.id}`)
      if (this.table.filters.status && this.table.filters.status.value){
        this.table.filters.status.value === 'ativos' && extraFilters.push(`&fechado=0`)
        this.table.filters.status.value === 'fechados' && extraFilters.push(`&fechado=1`)
        this.table.filters.status.value === 'ganhos' && extraFilters.push(`&ganho=1`)
        this.table.filters.status.value === 'perdidos' && extraFilters.push(`&perdido=1`)
      }

      /*if (Array.isArray(this.tags) && this.tags.length > 0) {
        extraFilters.push(`&tags=${this.tags.join(',')}`)
      }*/

      if (this.extraFilters && Array.isArray(this.extraFilters)) {
        this.extraFilters.map(ef => {
          extraFilters.push('&' + ef)
        })
      }

      this.table.loading = true
      let filtros = encodeURI(`&sortBy=${pagination.sortBy || 'createdAt'}&descending=${pagination.sortBy ? (pagination.descending ? 'true' : 'false') : true}${extraFilters.join('')}`)

      list(pagination.rowsPerPage, pagination.page, filtros, true)
          .then(({data}) => {
            this.table.serverPagination = pagination
            this.table.serverPagination.rowsNumber = data.total
            this.table.serverData = data.result
            this.table.loading = false
          })
          .catch(error => {
            this.alertApiError(error)
            this.loading = false
          })
    },
    load () {
      this.request({
        pagination: this.table.serverPagination,
        filter: this.table.busca
      })
    },
    clearFilters () {
      this.table.filters = JSON.parse(JSON.stringify(filters))
    },
    novo () {
      console.log('New...')
    },
    pesquisar () {
      this.request({
        pagination: this.table.serverPagination,
        filter: this.table.filters.search
      })
    },
    tabFilter (t) {
      if (this.table.filters.typeFilter === t) {
        this.table.filters = JSON.parse(JSON.stringify(filters))
        this.load()
        return
      }
      this.table.filters = JSON.parse(JSON.stringify(filters))
      this.table.filters.typeFilter = t
      this.load()
    }
  },
  meta: {
    title: 'CRM - Negócios',
    name: 'CrmLista'
  }
}
</script>

<template>
  <div class="crm-list">
    <div class="flex justify-between">
    </div>
    <u-table
        ref="table"
        color="primary"
        :data="table.serverData"
        :columns="table.columns"
        :visible-columns="visibledColumns"
        :filter="table.busca"
        row-key="id"
        :pagination.sync="table.serverPagination"
        @request="request"
        selection="multiple"
        :selected.sync="table.selected"
        :loading="table.loading"
        class="erp-table table-v2 table-shadow"
        :rows-per-page-options="[20, 50, 100]"
    >
      <template slot="top" slot-scope="props">
        <div class="sl-v2-table-filters full-width">
          <e-row class="e-input-modern size1">
            <e-col style="min-width: 150px" class="m-l m-r">
              <erp-s-field
                  view="ll"
                  label="Busca"
              >
                <erp-input placeholder="Busca Inteligente" v-on:keyup.enter="pesquisar" shortkey="F2" v-model="table.filters.search" />
              </erp-s-field>
            </e-col>
            <e-col style="max-width: 100px" class="m-l m-r">
              <erp-s-field
                  view="ll"
                  label="ID"
              >
                <erp-input v-on:keyup.enter="pesquisar" shortkey="F3" v-model="table.filters.id" />
              </erp-s-field>
            </e-col>
            <e-col style="min-width: 150px" class="m-l m-r">
              <erp-s-field view="ll" label="Status">
                <status-negocio-select v-model="table.filters.status" placeholder="Somente ativos" />
              </erp-s-field>
            </e-col>
            <e-col style="max-width: 80px">
              <e-btn @click="pesquisar" label="Filtrar" />
              <!--                  <u-btn @click="pesquisar" color="grey" size="sm" class="app-btn erp-btn text-white" no-caps>Filtrar</u-btn>-->
            </e-col>
            <e-col class="flex items-end content-end justify-end">
<!--              <u-btn @click="showFilters = !showFilters" color="blue-grey-1" size="sm" class="app-btn text-blue-grey-5" no-caps>
                &lt;!&ndash;    Mais filtros&ndash;&gt;
                <u-icon name="filter" class="m-l__ m-r-sm fin-icon-filter" type="fa"/>
                <span v-if="!showFilters">Mais Filtros</span>
                <span v-else>Menos Filtros</span>
              </u-btn>--> <!-- @TODO -->
            </e-col>
          </e-row>
          <e-row>
            <filtros-adicionais :filters="table.filters" v-show="showFilters" />
          </e-row>
        </div>
      </template>
      <u-tr slot="header" slot-scope="props">
        <!--        <u-th auto-width v-if="mode !== 'cliente'">
                  <u-checkbox
                      v-model="props.selected"
                      :indeterminate="props.partialSelected"
                      size="xs"
                  />
                </u-th>-->
        <u-th v-for="col in props.cols" :key="col.name" :props="props" :class="'col-' + col.name">
          <div v-if="col.name === 'options'" class="text-center">
            <u-btn style="margin: -10px 0 -6px" @click="listOptions" label="Configurar lista" rounded round flat no-caps size="xs" icon="cog" icon-type="fa" color="grey-4" class="text-grey-8"/>
          </div>
          <template v-else>{{col.label}}</template>
        </u-th>
      </u-tr>

      <u-tr slot="body" slot-scope="props"
            :props="props" :class="[{'u-table-item-destac': props.row.isToday}, trClass(props.row)]">
        <!--        <u-td class="pos-rlt" auto-width v-if="mode !== 'cliente'">
                  <u-checkbox color="primary" v-model="props.selected" size="xs"/>
                </u-td>-->
        <u-td :title="props.row.titulo" class="td-limit l-400 col-titulo" key="titulo"
              :props="props">
          <router-link tag="a" target="_blank" :to="{
        name: 'negocio',
        params: {
          id: props.row.id
        }
      }">{{ props.row.titulo }}</router-link>
        </u-td>
        <u-td style="max-width: 50px; min-width: 50px; width: 50px" key="id" :props="props" class="col-id">
          {{ props.row.id }}
        </u-td>
        <u-td key="pessoa" :props="props">
          {{ props.row.pessoa?.name }}
        </u-td>
        <u-td key="organizacao" :props="props">
          {{ props.row.organizacao?.name }}
        </u-td>
        <u-td key="dataFechamentoEsperada" :props="props">
          <div v-if="props.row.dataFechamentoEsperada">{{props.row.dataFechamentoEsperada|formatDate('dd/MM/yyyy')}}</div>
        </u-td>
        <u-td key="funil" :props="props">
          {{ props.row.funil?.nome }}
        </u-td>
        <u-td key="funilEtapa" :props="props">
          {{ props.row.funilEtapa?.nome }}
        </u-td>
        <u-td key="situacao" :props="props" style="cursor: default">
          <span v-if="props.row.ganho" class="flex items-center text-positive"><check-svg class="m-r-xs" /> Ganho</span>
          <span v-else-if="props.row.perdido" class="flex items-center text-negative"><alert-svg class="m-r-xs" /> Perdido</span>
          <span v-else>Aberto</span>
        </u-td>
        <u-td key="fechado" :props="props">
          <span v-if="props.row.fechado" class="text-purple font-bold">Sim</span>
          <span v-else class="text-black">Não</span>
        </u-td>
        <u-td key="options">
        </u-td>
        <!--        <u-td class="text-center" key="options" :props="props">
                </u-td>-->
      </u-tr>
    </u-table>
  </div>
</template>
